import * as Const from '../constants/actionConstants';

import { Action } from 'redux';

import FinishedForm from '../interfaces/FinishedForm';
import SubFinishedForm from '../interfaces/actions/SubFinishedForm';

export const subFinishedForm = (finishedForm: FinishedForm | {}): SubFinishedForm => {
  return {
    type: Const.SUB_FORM_FINISHED_FORM,
    finishedForm,
  };
};
export const subFormIsSending = (): Action => {
  return {
    type: Const.SUB_FORM_IS_SENDING,
  };
};

export const subFormNotSend = (): Action => {
  return {
    type: Const.SUB_FORM_NOT_SEND,
  };
};

export const subFormSentSuccess = (): Action => {
  return {
    type: Const.SUB_FORM_IS_SUCCESS,
  };
};
